import { createSelector } from '@reduxjs/toolkit'
import { type Address, getAddress } from 'viem'
import type { EnabledVaultsInfo } from '../types'

// this should be used for scaling the health score to a percentage bips
// otherwise there can be precision loss
// this can be used later to divide by the value and cast to Number
export const HEALTH_SCORE_SCALE = 10_000n

export const reduceHealthScore = createSelector(
  [(accountStatus: EnabledVaultsInfo[]) => accountStatus],
  (accountStatus) => {
    const data = new Map<Address, bigint>()

    for (const status of accountStatus) {
      if (!status) continue
      const vaultCheck = new Set<Address>()
      const { vaultAccountInfo, evcAccountInfo } = status
      const healthScores: bigint[] = []
      for (const vault of vaultAccountInfo) {
        if (
          !vaultCheck.has(getAddress(vault.vault)) &&
          vault.isController &&
          vault.liquidityInfo.liabilityValueBorrowing > 0n &&
          vault.liquidityInfo.collateralValueLiquidation > 0n
        ) {
          vaultCheck.add(getAddress(vault.vault))
          healthScores.push(
            (vault.liquidityInfo.collateralValueLiquidation * HEALTH_SCORE_SCALE) /
              vault.liquidityInfo.liabilityValueBorrowing,
          )
        }
      }

      if (healthScores.length === 1) {
        // @ts-ignore - healthScores[0] might be undefined
        data.set(getAddress(evcAccountInfo.account), healthScores[0])
      }
    }

    return data
  },
)
